import { jsx } from 'react/jsx-runtime';
import { cssRadixPopoverContentOverride } from '../Drawer/cssRadixPopoverOverride.js';
import { Drawer } from '../Drawer/Drawer.js';
import { Content } from '@radix-ui/react-dropdown-menu';
import React__default from 'react';
import { styled } from 'styled-components';

const DropdownContentMobileBase = styled(Content).withConfig({
  displayName: "ContentMobile__DropdownContentMobileBase",
  componentId: "sc-a8a8aa4-0"
})([
  `font-size:0.9375rem;`,
  ``
], cssRadixPopoverContentOverride);
const ContentMobile = /* @__PURE__ */ React__default.forwardRef(function DropdownContentMobile({ children, onOpenChange, onEscapeKeyDown }, ref) {
  return /* @__PURE__ */ jsx(DropdownContentMobileBase, {
    onEscapeKeyDown,
    ref,
    children: /* @__PURE__ */ jsx(Drawer, {
      panningLayerId: "dropdown-content",
      onOpenChange,
      children
    })
  });
});

export { ContentMobile };
//# sourceMappingURL=ContentMobile.js.map
